import React from 'react';
import { Button } from 'antd';

const Logout = (props: { onClick: () => void, className: string }) => {
  const { onClick, className } = props;
  return (
    <div className={className} >
      <Button 
        onClick={()=> {
          // logout();
          if (onClick) {
            onClick();
          }
        }}
      >
        登出
      </Button>
    </div>
  )
};

export default Logout;